export const formatCurrency = (amount) => {
    return `$${amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const getChartData = (
    consultas,
    egresos,
    period,
    selectedDate
) => {
    if (period === 'day') {
        // Para un día, mostrar por horas (agrupado en bloques de 3 horas)
        const hours = Array.from({ length: 8 }, (_, i) => {
            const startHour = i * 3;
            return {
                name: `${startHour}:00-${startHour + 3}:00`,
                ingresos: Math.floor(Math.random() * 2000) + 500,
                egresos: Math.floor(Math.random() * 1000) + 200
            };
        });
        return hours;
    } else if (period === 'month') {
        // Para un mes, mostrar por semanas
        const weeks = Array.from({ length: 4 }, (_, i) => {
            const weekStart = i * 7 + 1;
            const weekEnd = Math.min(weekStart + 6, 30);
            return {
                name: `${weekStart}-${weekEnd}`,
                ingresos: 0,
                egresos: 0
            };
        });

        // consultas.forEach((c) => {
        //     const day = c.fecha.getDate();
        //     const weekIndex = Math.floor((day - 1) / 7);
        //     if (weeks[weekIndex]) {
        //         weeks[weekIndex].ingresos += c.monto;
        //     }
        // });

        // egresos.forEach((e) => {
        //     const day = e.fecha.getDate();
        //     const weekIndex = Math.floor((day - 1) / 7);
        //     if (weeks[weekIndex]) {
        //         weeks[weekIndex].egresos += e.monto;
        //     }
        // });

        return [];
    } else {
        // Para un año, mostrar por meses
        const months = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
            'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];

        const monthlyData = months.map((name, index) => ({
            name,
            ingresos: 0,
            egresos: 0
        }));

        consultas.forEach((c) => {
            const monthIndex = c.fecha.getMonth();
            monthlyData[monthIndex].ingresos += c.monto;
        });

        egresos.forEach((e) => {
            const monthIndex = e.fecha.getMonth();
            monthlyData[monthIndex].egresos += e.monto;
        });

        // return monthlyData;
        return [];
    }
};

export const filterByPeriod = (data, period, selectedDate) => {
  return data.filter((item) => {
    const itemDate = item.fecha;

    if (period === 'day') {
      return (
        itemDate.getDate() === selectedDate.getDate() &&
        itemDate.getMonth() === selectedDate.getMonth() &&
        itemDate.getFullYear() === selectedDate.getFullYear()
      );
    } else if (period === 'month') {
      return (
        itemDate.getMonth() === selectedDate.getMonth() &&
        itemDate.getFullYear() === selectedDate.getFullYear()
      );
    } else {
      return itemDate.getFullYear() === selectedDate.getFullYear();
    }
  });
};